import React from 'react';
import NewsListItem from '../../molecules/NewsListItem/NewsListItem';
import { EmptyText } from '../../../Dashboard.styled';
import { HeroCard, Thumb, HeroBody, Tag, HeroTitle, HeroExcerpt, MiniCard } from './NewsRail.styled';

export interface NewsRailItem {
  id: string;
  tag: string;
  title: string;
  excerpt: string;
  dateLabel: string;
  /** URL firmada de la imagen; null/ausente → placeholder degradado. */
  imageUrl?: string | null;
}

export interface NewsRailProps {
  emptyText: string;
  hero: NewsRailItem | null;
  items: NewsRailItem[];
  /** Click en el hero o en un item de la lista; abre el detalle. */
  onItemClick?: (id: string) => void;
}

export default function NewsRail({ emptyText, hero, items, onItemClick }: NewsRailProps) {
  if (!hero && items.length === 0) return <EmptyText>{emptyText}</EmptyText>;

  return (
    <section>
      {hero && (
        <HeroCard
          clickable={Boolean(onItemClick)}
          role={onItemClick ? 'button' : undefined}
          tabIndex={onItemClick ? 0 : undefined}
          onClick={() => onItemClick?.(hero.id)}
          onKeyDown={event => {
            if (onItemClick && (event.key === 'Enter' || event.key === ' ')) {
              event.preventDefault();
              onItemClick(hero.id);
            }
          }}
        >
          <Thumb imageUrl={hero.imageUrl ?? null} />
          <HeroBody>
            <Tag>{hero.tag}</Tag>
            <HeroTitle>{hero.title}</HeroTitle>
            {hero.excerpt && <HeroExcerpt>{hero.excerpt}</HeroExcerpt>}
          </HeroBody>
        </HeroCard>
      )}
      {items.length > 0 && (
        <MiniCard>
          {items.map(item => (
            <NewsListItem
              key={item.id}
              title={item.title}
              dateLabel={item.dateLabel}
              onClick={onItemClick ? () => onItemClick(item.id) : undefined}
            />
          ))}
        </MiniCard>
      )}
    </section>
  );
}
